import { useTimeOfDay } from '../hooks/useTimeOfDay'

const orbColors = {
  morning: ['#ec6649', '#e18b69', '#f3e2d0'],
  afternoon: ['#b34236', '#ec6649', '#e18b69'],
  night: ['#3e211e', '#b34236', '#6b2e28'],
} as const

export default function AmbientOrb() {
  const timeOfDay = useTimeOfDay()
  const [c1, c2, c3] = orbColors[timeOfDay]

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden>
      <div
        className="ambient-orb absolute w-[40vw] h-[40vw] max-w-[600px] max-h-[600px] rounded-full opacity-[0.07] blur-[100px]"
        style={{
          background: `radial-gradient(circle, ${c1}, ${c2}, ${c3}00)`,
          top: '20%',
          left: '60%',
          transition: 'background 3s ease',
        }}
      />
      <div
        className="ambient-orb-2 absolute w-[30vw] h-[30vw] max-w-[450px] max-h-[450px] rounded-full opacity-[0.05] blur-[80px]"
        style={{
          background: `radial-gradient(circle, ${c2}, ${c3}, ${c1}00)`,
          top: '60%',
          left: '10%',
          transition: 'background 3s ease',
        }}
      />
    </div>
  )
}
